/** Stable keys aligned with `@valvur/shared-grpc` feature-flag catalog (browser-safe copy). */
export const PATROL_PLATFORM_FLAG_KEY = {
  DISCORD: 'patrol.discord',
  ROBLOX: 'patrol.roblox',
} as const;

export const PATROL_PLATFORM_FLAG_DESCRIPTION: Record<
  (typeof PATROL_PLATFORM_FLAG_KEY)[keyof typeof PATROL_PLATFORM_FLAG_KEY],
  string
> = {
  [PATROL_PLATFORM_FLAG_KEY.DISCORD]:
    'When enabled, Discord Patrol partner APIs and ingress are available via api-gateway.',
  [PATROL_PLATFORM_FLAG_KEY.ROBLOX]:
    'When enabled, Roblox Patrol partner APIs and game-server ingress are available via api-gateway.',
};
